<ion-button *ngIf="attachments.length" expand="block" (click)="showAttachments()">
  <ion-icon slot="start" name="attach"></ion-icon>
  {{ 'Mobile.Attachments' | translate }} ({{ attachments.length }})
</ion-button>
